"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const Button_1 = require("~/components/UI/Button");
const ErrorModal_module_scss_1 = __importDefault(require("./ErrorModal.module.scss"));
function ErrorModal({ messages, header, icon, imgClassName, errorBoundary = false }) {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { t } = (0, react_i18next_1.useTranslation)('messages');
    const handleError = () => {
        navigate('/', { replace: true });
        if (errorBoundary) {
            window.location.reload();
        }
    };
    return (react_1.default.createElement("div", { className: ErrorModal_module_scss_1.default.overlay },
        react_1.default.createElement("div", { className: ErrorModal_module_scss_1.default.window },
            react_1.default.createElement("div", { className: ErrorModal_module_scss_1.default.widget },
                react_1.default.createElement("div", { className: ErrorModal_module_scss_1.default.backgroundImage },
                    react_1.default.createElement("img", { src: icon, alt: "logo", className: `img ${ErrorModal_module_scss_1.default[imgClassName]}` })),
                react_1.default.createElement("div", { className: ErrorModal_module_scss_1.default.actionContainer },
                    react_1.default.createElement("div", { className: ErrorModal_module_scss_1.default.descriptionContainer },
                        react_1.default.createElement("h1", null, header),
                        react_1.default.createElement("div", { className: ErrorModal_module_scss_1.default.description }, messages.map((message, index) => {
                            return (react_1.default.createElement("div", { key: message + String(index) },
                                react_1.default.createElement("span", null, message),
                                react_1.default.createElement("br", null)));
                        }))),
                    react_1.default.createElement("div", { className: ErrorModal_module_scss_1.default.buttonContainer },
                        react_1.default.createElement(Button_1.Button, { wide: true, variant: "primary", onClick: handleError }, errorBoundary ? t('reload-page') : t('close'))))))));
}
exports.default = ErrorModal;
